// Converted to Tailwind, removing Typography usage
import { DefiImg } from "@components/StorageImage";
import { Button } from "@kelp-dao/kernel-design-system";
import { DeFiRow } from "@components/V2/Vault/Common/DefiTypes";

interface DefiItemCardProps {
  row: DeFiRow;
  cardCount?: number;
  isMobile?: boolean;
  showBorder?: boolean;
}

const getPairText = (input: string) => {
  if (input.includes(" - ")) {
    const [part1, part2] = input.split(" - ").map((str) => str.trim());
    return part1 + "- " + part2;
  } else {
    return input.trim();
  }
};

export const DefiItemCard = ({
  row,
  cardCount = 4,
  isMobile = false,
  showBorder = true,
}: DefiItemCardProps) => {
  // Dynamic width based on card count and device type
  const getCardWidth = () => {
    if (isMobile) return "w-full";
    if (cardCount <= 3) return "w-1/3";
    return "min-w-[280px] flex-shrink-0";
  };

  return (
    <div
      className={`${
        showBorder
          ? "bg-bg-card border border-border-default rounded-xl p-2 md:px-3 md:py-4 transition-colors hover:cursor-pointer hover:shadow-md"
          : "p-0 py-2"
      } ${getCardWidth()}`}
      onClick={() => {
        if (!isMobile) {
          window.open(row["Add Liquidity"], "_blank");
        }
      }}
    >
      <div className={`flex gap-2 ${isMobile ? "flex-row" : "flex-row"}`}>
        {/* Column 1: Image Column (Small) */}
        <div className="flex-shrink-0">
          <div className="relative flex -space-x-3">
            <div
              className={`rounded-full border-2 border-white bg-gray-100 flex items-center justify-center ${
                isMobile ? "w-6 h-6" : "w-8 h-8"
              }`}
            >
              <DefiImg
                img={row["Token 1 Icon"]}
                width={isMobile ? 6 : 8}
                height={isMobile ? 6 : 8}
              />
            </div>
            <div
              className={`rounded-full border-2 border-white bg-gray-100 flex items-center justify-center ${
                isMobile ? "w-6 h-6" : "w-8 h-8"
              }`}
            >
              <DefiImg
                img={row["Token 2 Icon"]}
                width={isMobile ? 6 : 8}
                height={isMobile ? 6 : 8}
              />
            </div>
          </div>
        </div>

        {/* Column 2: Details Column */}
        <div className="flex-1 min-w-0">
          {/* Row 1: Title and Menu Icon */}
          <div className="flex justify-between items-start mb-2">
            <h3
              className={`font-semibold text-text-primary truncate ${
                isMobile ? "text-base" : "text-lg"
              }`}
            >
              {getPairText(row.Pair)}
            </h3>
          </div>
          {/* Row 2: Tags */}
          {/* <div className="mb-3 tablet:mb-4">
            {defiJSON.allTags &&
              (row.Activity || row.TagWithImage || row.Tags) && (
                <DefiRowTags
                  allTags={defiJSON.allTags.data}
                  tags={[row.Activity, row.Tags, row.TagWithImage].join(",")}
                  tagWithImage={row.TagWithImage}
                  tagImagePath={row.TagImagePath}
                  featuredDefi
                />
              )}
          </div> */}

          {/* Row 3: Divider */}
          <div className="tablet:border-t border-border-default mb-3 tablet:mb-4"></div>

          {/* Row 4: Stats */}
          <div className={isMobile ? "flex gap-6 " : "space-y-2 tablet:space-y-3"}>
            <div
              className={
                isMobile ? "flex flex-col" : "flex justify-between items-center"
              }
            >
              <span className="text-sm text-text-secondary font-medium">
                TVL
              </span>
              <span className="text-sm tablet:text-base font-semibold text-text-primary">
                {row.TVL || "-"}
              </span>
            </div>
            <div
              className={
                isMobile ? "flex flex-col" : "flex justify-between items-center"
              }
            >
              <span className="text-sm text-text-secondary font-medium">
                APY
              </span>
              <span className="text-sm tablet:text-base font-semibold text-text-primary">
                {row.APY || "-"}
              </span>
            </div>
            {/* Row 5: Mobile Action Buttons */}
            {isMobile && (
              <div className="flex gap-2 py-0 items-center m-auto">
                {row["Add Liquidity"] && (
                  <Button
                    variant="outline"
                    size="xsmall"
                    className="px-3 h-8"
                    onClick={(e: any) => {
                      e.stopPropagation();
                      window.open(row["Add Liquidity"], "_blank");
                    }}
                  >
                    Add Liquidity
                  </Button>
                )}
                {row.Swap && (
                  <Button
                    variant="outline"
                    size="xsmall"
                    className="px-3 h-8"
                    onClick={(e: any) => {
                      e.stopPropagation();
                      window.open(row.Swap, "_blank");
                    }}
                  >
                    Swap
                  </Button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefiItemCard;
